// extracted by mini-css-extract-plugin
export var typingIndicator = "_kq-0";